import { useEventSpaces } from "@circle-react/components/Events/hooks/useEventSpaces";
import { useCreateEventModal } from "@circle-react/components/Modals/CreateEventModal";
import type { Event } from "@circle-react/types/Event";

export interface UseCreateEventProps {
  onSuccess?: (event: Event) => void;
}

export const useCreateEvent = ({ onSuccess }: UseCreateEventProps = {}) => {
  const { spaceId } = useEventSpaces();
  const createEventModal = useCreateEventModal();
  const showCreateEventModal = () =>
    createEventModal.show({ spaceId, onSuccess });

  return {
    showCreateEventModal,
  };
};
